import moment from 'moment-timezone';

moment.tz.setDefault('America/Sao_Paulo');

moment.locale('pt-br');

export default {
  data() {
    return {
      rules: {
        required: v => !!v || 'Campo requerido.',
        emailRules: v => /.+@.+/.test(v) || 'E-mail precisa ser válido',
        min8: v => (!!v && v.length) > 7 || 'Necessário 8 ou mais caracteres',
        date: (v) => {
          if (v) {
            if (v.length >= 10) {
              const date = moment(v, 'DD/MM/YYYY').tz('America/Sao_Paulo');
              return date.isValid() || 'Data incorreta';
            }
            return 'Data incorreta';
          }
          return false;
        },
      },
    };
  },
};
